module.exports = __webpack_public_path__ + "static/media/success.877a0858.png";